import moment from 'moment-timezone'
import {
    CaretLeftOutlined,
    CaretRightOutlined,
    ReloadOutlined,
    SelectOutlined,
    ZoomInOutlined,
    ZoomOutOutlined,
} from '@ant-design/icons'
import { Button as AntdButton, Space } from 'antd'
import { SHORT_DATE_TIME_FORMAT } from '@OpsQuality/constants'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Text from '~/core/Text'
import { PreviewModalFooterType } from '~/components/FileUploadList/components/types'
import { MODULE_TYPES } from '~/components/FileUploadList/components/logic'
import attachmentStyles from '~/components/FileUploadList/components/styles.css'

const ButtonGroup = AntdButton.Group
const PLACEMENT = 'file-list-modal'
const ZOOM_SCALE = 0.5
const SPACE_SIZE = 0

export default function PreviewModalFooter(props: PreviewModalFooterType) {
    const {
        referentialAttachments,
        selectedFileState,
        removeAttachments,
        modalControls: { backFwd, newWindow, rotate, zoom },
        rotateImg,
        toggleAttachment,
        openInNew,
        zoomIn,
        zoomOut,
        canAttachmentBeDeleted,
        leftButtonDisabled,
        rightButtonDisabled,
        typeOfModule,
    } = props

    const { selectedFile, isImage, scale } = selectedFileState

    const deleteAttachment = () => {
        if (typeOfModule === MODULE_TYPES.INVENTORY_QC) {
            return (
                <>
                    {referentialAttachments.length > 1 &&
                        removeAttachments(referentialAttachments)}
                    {selectedFileState?.selectedFile &&
                        removeAttachments([selectedFileState.selectedFile])}
                </>
            )
        } else if (
            [MODULE_TYPES.WO_EXCPETION_LIST, MODULE_TYPES.CAR_DETAILS].includes(
                typeOfModule,
            )
        ) {
            return (
                <>
                    {selectedFileState?.selectedFile &&
                        removeAttachments([selectedFileState.selectedFile])}
                </>
            )
        }
        return removeAttachments(referentialAttachments)
    }

    return (
        <div>
            <Box justifyContent="between">
                <div>
                    <ButtonGroup>
                        {backFwd && (
                            <Space size={SPACE_SIZE}>
                                <Button
                                    disabled={leftButtonDisabled()}
                                    onClick={() => toggleAttachment()}
                                    data-test-target="previous-inspection-document"
                                    className={attachmentStyles.fileListButton}
                                    name="left"
                                    placement={PLACEMENT}
                                >
                                    <CaretLeftOutlined />
                                </Button>
                                <Button
                                    disabled={rightButtonDisabled()}
                                    onClick={() => toggleAttachment(true)}
                                    data-test-target="next-inspection-document"
                                    className={attachmentStyles.fileListButton}
                                    name="right"
                                    placement={PLACEMENT}
                                >
                                    <CaretRightOutlined />
                                </Button>
                            </Space>
                        )}
                    </ButtonGroup>
                    {selectedFile && (
                        <Text fontSize="14px" style={{ marginLeft: '16px' }}>
                            {`Uploaded at ${moment(
                                selectedFile?.createdAt,
                            ).format(SHORT_DATE_TIME_FORMAT)}`}
                        </Text>
                    )}
                </div>
                <div>
                    <ButtonGroup>
                        {zoom && (
                            <Space size={SPACE_SIZE}>
                                <Button
                                    name="zoom-in"
                                    placement={PLACEMENT}
                                    disabled={!isImage}
                                    onClick={zoomIn}
                                    className={attachmentStyles.fileListButton}
                                    data-test-target="zoom-in-inspection"
                                >
                                    <ZoomInOutlined />
                                </Button>
                                <Button
                                    name="zoom-out"
                                    placement={PLACEMENT}
                                    disabled={scale <= ZOOM_SCALE || !isImage}
                                    onClick={zoomOut}
                                    className={attachmentStyles.fileListButton}
                                    data-test-target="zoom-out-inspection"
                                >
                                    <ZoomOutOutlined />
                                </Button>
                            </Space>
                        )}
                    </ButtonGroup>
                    <ButtonGroup style={{ marginLeft: 5 }}>
                        {rotate && (
                            <Space size={SPACE_SIZE}>
                                <Button
                                    name="rotation"
                                    placement={PLACEMENT}
                                    onClick={() => {
                                        rotateImg(true)
                                    }}
                                    disabled={!isImage}
                                    className={attachmentStyles.fileListButton}
                                    data-test-target="rotate-left-inspection"
                                >
                                    <ReloadOutlined />
                                </Button>
                                <Button
                                    name="rotation-clockwise"
                                    placement={PLACEMENT}
                                    onClick={() => {
                                        rotateImg()
                                    }}
                                    disabled={!isImage}
                                    className={attachmentStyles.fileListButton}
                                    data-test-target="rotate-right-inspection"
                                >
                                    <ReloadOutlined
                                        style={{
                                            transform: `rotate(360deg) scaleX(-1)`,
                                        }}
                                    />
                                </Button>
                            </Space>
                        )}
                    </ButtonGroup>
                    {canAttachmentBeDeleted && deleteAttachment()}
                    {newWindow && (
                        <Button
                            name="select"
                            placement={PLACEMENT}
                            type="primary"
                            onClick={() =>
                                selectedFileState.selectedFile?.attachment
                                    ?.downloadUrl &&
                                openInNew(
                                    selectedFileState.selectedFile?.attachment
                                        ?.downloadUrl,
                                )
                            }
                            style={{
                                marginLeft: 5,
                            }}
                            className={attachmentStyles.fileListButton}
                        >
                            <SelectOutlined />
                        </Button>
                    )}
                </div>
            </Box>
        </div>
    )
}
